<template>
  <div class="panelHead">
    <div class="panelHeadLeft">
      <span v-if="needBack" class="retuBtn" @click="back"><i class="el-icon-arrow-left" /></span>
      <span class="panelHeadTitle">{{ title }}</span>
    </div>
    <div class="panelHeadRight">
      <slot />
      <el-dropdown trigger="click" @command="onUserCommand">
        <span class="user-entry">
          <el-avatar size="small" class="user-avatar">{{ avatarText }}</el-avatar>
          <span class="user-name">{{ displayName }}</span>
          <i class="el-icon-arrow-down" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">个人资料</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { clearLoginState, goPasswordLogin, isInDingTalk, loginByDingTalk } from '@/utils/login'
export default {
  name: 'TitleBar',
  data() {
    return {
      title: '',
      needBack: false
    }
  },
  computed: {
    ...mapGetters({
      visitedRoutes: 'visitedRoutes',
      userId: 'userId',
      userInfo: 'userInfo',
    }),
    displayName() {
      return (this.userInfo && this.userInfo.name) || '用户'
    },
    avatarText() {
      const name = this.displayName
      return name ? name.substring(0, 1) : '用'
    },
  },
  watch: {
    $route(n) {
      this.title = n.meta.title;
      this.needBack = n.meta.needBack ? n.meta.needBack : false
    },
    userId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadUserInfo()
        }
      }
    }
  },
  created() {
    this.title = this.$route.meta.title;
    this.needBack = this.$route.meta.needBack ? this.$route.meta.needBack : false
  },
  methods: {
    loadUserInfo() {
      this.$http.get('/api/user/' + this.userId).then(res => {
        if (res.success) {
          this.$store.commit('demo/SET_USERINFO', res.data)
        }
      })
    },
    onUserCommand(cmd) {
      if (cmd === 'profile') {
        this.$router.push('/profile')
      } else if (cmd === 'logout') {
        if (isInDingTalk()) {
          clearLoginState()
          loginByDingTalk(() => {
            this.$router.replace('/home')
          })
        } else {
          goPasswordLogin()
        }
      }
    },
    async back() {
      this.$router.back();
      let view;
      let tabActive = this.$route.path
      this.visitedRoutes.forEach((item) => {
        if (tabActive == item.path) {
          view = item;
        }
      });
      await this.$store.dispatch('tabsBar/delRoute', view);
    }
  }
}
</script>
<style lang="scss" scoped>
.panelHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 0 30px;
  background: #fff;
  height: 60px;
  width: 100%;
  .panelHeadLeft {
    .retuBtn {
      cursor: pointer;
      font-size: 16px;
      color: #098cfc;
      margin-right: 30px;
      i { font-size: 20px; }
    }
    .panelHeadTitle {
      cursor: default;
      user-select: none;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }
  .panelHeadRight {
    display: flex;
    align-items: center;
  }
  .user-entry {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #333;
  }
  .user-avatar {
    background: #098cfc;
    margin-right: 8px;
  }
  .user-name {
    margin-right: 4px;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
